export default __webpack_public_path__ + "static/media/2.ccf9b0a1.jpg";